class CurrencyHelper {
  static format(locale, currency, number) {
    if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(number);
    }
    // Fallback
    return Number.parseFloat(number).toFixed(2);
  }
}

export default CurrencyHelper;
